var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 10,
    fill: "#25B361",
    fillOpacity: 0.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3749 24.5706C21.7879 27.3185 21.0313 28.8208 18.8948 29.1367C16.5206 29.4878 15.5423 27.8974 15.1293 25.1496C14.5738 21.4521 15.8793 19.1524 17.7407 19.0042C19.4348 18.8697 20.9615 21.8233 21.3749 24.5706ZM22.4835 32.1967C22.6303 33.7567 21.787 35.2127 20.5148 35.4621C19.2304 35.7133 17.7628 34.6947 17.4637 33.1563C17.1646 31.6178 18.2957 31.5363 19.6818 31.2714C21.0679 31.0066 22.3063 30.3152 22.4835 32.1967ZM26.6249 20.0702C26.212 22.818 26.9685 24.3203 29.1046 24.6363C31.4793 24.9874 32.4571 23.3969 32.8701 20.6491C33.426 16.9511 32.1201 14.6388 30.2592 14.5038C28.5529 14.38 27.0384 17.3224 26.6249 20.0702ZM25.5163 27.6967C25.3696 29.2563 26.2129 30.7127 27.4851 30.9621C28.7695 31.2133 30.2371 30.1947 30.5362 28.6563C30.8353 27.1178 29.7042 27.0363 28.3181 26.771C26.932 26.5056 25.6935 25.8147 25.5163 27.6967Z",
    stroke: "#25B361",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/Steps.b92ee322d337610c3a75fefe972b9adc.svg";
export { ForwardRef as ReactComponent };